<script lang="ts">
import { h, type FunctionalComponent, type VNode } from 'vue';

export interface PhxsgWrapperProps {
  if?: boolean;
  use?: string;
}

const PhxsgWrapper: FunctionalComponent<PhxsgWrapperProps> = (props, { slots, attrs }) => {
  const children = slots.default?.() as VNode[];
  const { if: shouldWrap = true, use = 'div' } = props;

  if (shouldWrap) {
    return h(use, attrs, children);
  }

  return children;
};

export default PhxsgWrapper;
</script>
